<template>
    <div class="myComplaint-detail">
        <div class="title">
            <div class="title-text">
                <span>投诉详情</span>
            </div>
        </div>
        <section>

			<div v-for="statusData in statusList" v-bind:key="statusData.name">
				<el-steps  :active="statusData.statusActive" finish-status="success" class="steprow">
					<el-step :key="item.key" :title="item.key" v-for="item in statusData.statusList" ></el-step>
				</el-steps>
			</div>
            <div class="btnrow">
                <el-button :key="btn.key" type="primary" v-for="btn in buttonList" :disabled="btn.value == 0" @click="feedbackOperate(btn.key)">{{btn.key}}</el-button>
            </div>
            <p v-for="item in contextList" :key="item.key" :class="item.indexOf('请关注订单退款详情') > -1 ? 'redfont' : ''" class="contextline">{{item}}</p>
        </section>
        <div class="shadow" v-if="showShadow">
            <div class="offline-refund">
                <div class="close" @click="cancle">&times;</div>
                <div class="confirm-title">确认与用户协商一致，关闭客诉！</div>
                <div class="confirm-tip">提示：百度客服会回访客户，如果用户未满意下关闭投诉，将影响您的资金结算等功能使用。</div>
                <div>
                    <span class="mixing">*</span>
                    <span class="merchant-input">商家备注：</span>
                    <el-input
                        type="textarea"
                        placeholder="请录入业务处理相关信息，200字以内"
                        v-model="merchantValue"
                        maxlength="200"
                        show-word-limit
                        clearable>
                    </el-input>
                </div>
                <div class="upload">
                    <span class="merchant-input">上传凭证：</span>
                    <el-upload
                        action="/platform/interface/uploadimg"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-exceed="handleExceed"
                        name="imgFile"
                        :limit="3"
                        :before-upload="beforeAvatarUpload"
                        :on-success="handleAvatarSuccess">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <div slot="tip" class="el-upload__tip">只能上传jpeg/png/bmp文件，图片清晰，不小于500kb，不大于2M</div>
                    <div slot="tip" class="el-upload__tip">最多上传3张，线下退款建议上传凭证</div>
                </div>
                <div class="alert-button">
                    <el-button size="small" @click="cancle">取消</el-button>
                    <el-button size="small" type="primary" @click="confirmSubmit">确认</el-button>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <h1 class="area-title">投诉单信息</h1>
        <div class="left-padding">
            <el-table
                :data="customerComplainInfo"
                border>
                <el-table-column
                    prop="channelName"
                    width="80"
                    label="投诉来源">
                </el-table-column>
                <el-table-column
                    prop="appId"
                    width="80"
                    label="APPID">
                </el-table-column>
                <el-table-column
                    prop="feedbackTime"
                    width="180"
                    label="投诉时间">
                </el-table-column>
                <el-table-column
                    prop="payAmount"
                    width="180"
                    label="交易金额（元）">
					<template slot-scope="scope">
						<span>{{scope.row.payAmount}}</span><span class="canrefundmoney">{{scope.row.refundAmount}}</span>
					</template>
                </el-table-column>
                <el-table-column
                    prop="userNickName"
                    width="140"
                    label="投诉用户昵称">
                </el-table-column>
                <el-table-column
                    prop="userPhone"
                    width="116"
                    label="用户联系方式">
                </el-table-column>
				<el-table-column
                    
                    prop="feedbackDesc"
                    label="投诉描述">
                </el-table-column>
            </el-table>
        </div>
        <h1 class="area-title" v-if="goodsList.length > 0">订单信息</h1>
        <div class="left-padding">
            <el-table
                v-if="goodsList.length > 0"
                :data="goodsList"
                border>
                <el-table-column
                    prop="dealId"
                    label="dealId">
                </el-table-column>
                <el-table-column
                    prop="dealTitle"
                    label="商品名称">
                </el-table-column>
                <el-table-column
                    prop="orderId"
                    label="平台订单">
                </el-table-column>
                <el-table-column
                    prop="tpOrderId"
                    label="第三方订单">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="订单创建时间">
                </el-table-column>
                <el-table-column
                    prop="payTime"
                    label="实际支付时间">
                </el-table-column>
                <el-table-column
                    prop="city"
                    label="城市">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="用户手机号">
                </el-table-column>
                <el-table-column
                    prop="takeInfo"
                    label="收货信息">
                </el-table-column>

				<el-table-column
                    prop="payAmount"
                    label="支付金额（单位元)">
                </el-table-column>
                <el-table-column
                    prop="thirdMarketingAmount"
                    label="第三方营销金额（单位元）">
                </el-table-column>
                <el-table-column
                    prop="marketingAmount"
                    label="营销金额（单位元）">
                </el-table-column>
                <el-table-column
                    prop="payChannel"
                    label="支付渠道">
                </el-table-column>
            </el-table>
        </div>
        <h1 class="area-title" v-if="refundList.length > 0">退款信息</h1>
        <div class="left-padding">
            <el-table
                v-if="refundList.length > 0"
                :data="refundList"
                border>
                <el-table-column
                    prop="refundBatchId"
                    label="退款序号">
                </el-table-column>
                <el-table-column
                    prop="applyRefundTime"
                    label="退款申请时间">
                </el-table-column>
                <el-table-column
                    prop="refundReason"
                    label="退款理由">
                </el-table-column>
                <el-table-column
                    prop="refundMoney"
                    label="退款金额(单位元)">
                </el-table-column>
                <el-table-column
                    prop="refundTpPropertyMoney"
                    label="第三方营销金额(单位元）">
                </el-table-column>
                <el-table-column
                    prop="refundPlatformPropertyMoney"
                    label="营销金额(单位元）">
                </el-table-column>
                <el-table-column
                    prop="refundStatusDesc"
                    label="退款状态">
                </el-table-column>
                <el-table-column
                    prop="refundWayDesc"
                    label="退款渠道">
                </el-table-column>
            </el-table>
        </div>
        <section v-if="merchantInfo">
            <h1 class="area-title">商户信息</h1>
            <div class="left-padding">
                <div class="item-wrap" >
                    <div class="item-title">商家名称：</div>
                    <div>{{merchantInfo.merchantName}}</div>
                </div>
                <div class="item-wrap">
                    <div class="item-title">运营电话：</div>
                    <div>{{merchantInfo.operationPhone}}</div>
                </div>
                <div class="item-wrap">
                    <div class="item-title">客服电话：</div>
                    <div>{{merchantInfo.servicePhone}}</div>
                </div>
                <div class="item-wrap">
                    <div class="item-title">其他电话：</div>
                    <div>{{merchantInfo.otherPhone}}</div>
                </div>
            </div>
        </section>
        <h2 class="area-title">协商详情</h2>
		
        <el-timeline>
            <el-timeline-item :key="item.name" v-for="item in consultList"  :timestamp="item.createtimeStr" placement="top">
                <el-card>
                    <h4>{{item.statusDesc}}</h4>
                    <p v-if="!item.pictures">{{item.content}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.refuseReason}}</p>
                    <div v-else>
                        <p>{{item.content}}</p>
                        <p>商户备注：{{item.refuseReason}}</p>
                    </div>
                    <div v-if="item.pictures" class="timeline-img">
                        <img :src="pic" v-for="(pic, index) in item.pictures.split(';')" :key="index" @click="showBig(index)" class="showImg">
                    </div>
                    <el-dialog v-if="item.pictures.split(';')[showBigIndex]" :visible.sync="imgDialogVisible">
                        <img width="100%" :src="item.pictures.split(';')[showBigIndex]" alt="">
                    </el-dialog>
                </el-card>
            </el-timeline-item>
        </el-timeline>
        <el-dialog
            title="退款"
            :visible.sync="refundDialogVisible"
            width="30%">
            <el-form ref="form" :model="refundForm" label-width="80px">
                <el-form-item style="position:relative"  class="refundtype">
                    <template>
                        <el-radio v-model="refundForm.refundType" @change="refundForm.refundMoney = refundableMoney" label="1" class="refundradio">全额退款</el-radio>
                        <el-radio v-model="refundForm.refundType" @change="refundForm.refundMoney = 0" label="2" class="refundradior">部分退款</el-radio>
                    </template>
                </el-form-item>
                <el-form-item label="退款金额:">
                    <el-input-number v-model="refundForm.refundMoney" :disabled="refundForm.refundType == 1"
					:placeholder="'最多可退款' + refundableMoney + '元'" :precision="2"
					:step="1"  :min="0"></el-input-number><span class="money">元</span>
                    <!-- <el-input :max="refundableMoney" v-model="refundForm.refundMoney" :disabled="refundForm.refundType == 1" :placeholder="'最多可退款' + refundableMoney + '元'" type="number"></el-input> -->
                </el-form-item>
                <p class="notice refundnotice">注：同意退款后，系统将货款自动退还给用户</p>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onRefundDialogCancel" class="closebtn">关闭</el-button>
                <el-popconfirm 
                v-if="refundForm.refundType == 2 && refundForm.refundMoney == refundableMoney"
                confirm-button-text='确定'
                cancel-button-text='不用了'
                icon="el-icon-info"
                @onConfirm="refund"
                icon-color="red"
                title="部分退款金额等于最大可退金额，确定退款吗？"
                >
                    <el-button type="primary" slot="reference" @confirm="refund" style="margin-left:10px">同意退款</el-button>
                 </el-popconfirm>
                <el-button type="primary" v-else @click="refund">同意退款</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            // 线下退款图片上传
            dialogImageUrl: '',
            dialogVisible: false,
            imgDialogVisible: false,
            // 点击放大的index值
            showBigIndex: '',
            imgUrlStr: '',
            // 商家备注
            merchantValue: '',
            showShadow: false,
            refundableMoney: 0,
            operateStatus: '',
            operateStatusList: [
                {
                    key: '开始处理',
                    value: 1
                },
                {
                    key: '退款处理',
                    value: 2
                },
                {
                    key: '投诉关闭',
                    value: 3
                },
                {
                    key: '提交客服处理',
                    value: 4
                },
                {
                    key: '线下退款',
                    value: 5
                }
            ],
            merchantInfo: {
                merchantName: '',
                operationPhone: '',
                servicePhone: '',
                otherPhone: ''
            }, // 商户信息
            buttonList: [],
            customerComplainInfo: {
			},
            consultList: [],
            contextList: [],
            statusActive: 0, // 步骤条当前进度
            feedBackId: '',
            statusList: [],
            form: {},
            orderList: [],
            refundList: [],
            goodsList: [],
            orderId: '',
            refundForm: {
                feedBackId: '',
                refundMoney: '',
                refundType: ''
            },
            deliverDialogVisible: false,
            refundDialogVisible: false,
            expressComList: []
        };
    },
    mounted() {
        this.feedBackId = this.$route.query.feedBackId;
        this.getDetail();
        this.getOrderDetail();
    },
    methods: {
        
        // 图片点击放大
        showBig(index) {
            this.showBigIndex = index;
            this.imgDialogVisible = true;
        },
        async handleOperate() {
            let res = await this.$api.feedbackOperate({
                feedBackId: this.feedBackId,
                buttonStatus: this.operateStatus
            });
            if (res.code === 0) {
                this.opreateSuccess();
            }
            else {
                this.$message.error(res.msg);
            }
        },
        opreateSuccess() {
            this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
                duration: 0,
                offset: 300
            });
            setTimeout(()=> {
                location.reload();
            }, 3000);
        },
        feedbackOperate(key) {
            const operateStatus = this.operateStatusList.filter(item => item.key == key);
            const val = operateStatus[0].value;
            this.operateStatus = val;
            // 投诉关闭, 线下退款
            if (val === 3 || val === 5) {
                this.merchantValue = '';
                this.imgUrlStr = '';
                this.showShadow = true;
            }
            // 退款
            else if (val === 2) {
                this.queryRefundableMoney(this.feedBackId);
            }
            else {
                this.handleOperate();
            }
        },
        queryRefundableMoney(feedBackId) {
            this.$api.queryRefundableMoney({feedBackId: feedBackId}).then(res => {
                if (res.errno === 0) {
                    this.refundableMoney = res.data.refundableMoney / 100;
                    this.refundDialogVisible = true;
                }
                else {
                    this.$message.error(res.msg);
                }
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });    
        },
        onDeliverDialogCancel() {
            this.deliverDialogVisible = false;
            this.resetDeliverForm();
        },
        onReturn() {
            this.$router.go(-1);
        },
        onRefundDialogCancel() {
            this.refundDialogVisible = false;  
        },
        resetRefundForm() {
            this.refundForm = {
                orderId: '',
                tpOrderId: '',
                refundReason: '',
                uid: ''
            }
        },
        refund() {
            this.refundForm.feedBackId = this.feedBackId;
            let data = {...this.refundForm};
            data.refundMoney = data.refundMoney * 100;
            if (!data.refundMoney || data.refundMoney == 0) {
                this.$message.error('请选择退款方式并输入退款金额');
                return;
            }
            if (data.refundMoney > this.refundableMoney * 100) {
                this.$message.error('不可大于可退金额');
                return;
            }
            this.$api.feedbackRefund(data).then(res => {
                if (res.code === 0) {
                    this.onRefundDialogCancel();
                    this.opreateSuccess();
                }
                else {
                    this.$message.error(res.msg);
                }
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        cancle() {
            this.showShadow = false;
        },
        confirmSubmit() {
            if (!this.merchantValue.trim()) {
                this.$message('商家备注为必填项');
                return;
            }
            let params = {
                feedBackId: this.$route.query.feedBackId,
                buttonStatus: this.operateStatus,
                applyReason: this.merchantValue,
                voucherImages: this.imgUrlStr.substring(0, this.imgUrlStr.length - 1)
            };
            this.$api.feedbackOperate(params).then(res => {
                if (+res.code) {
                    this.$message.error(res.msg);
                    return;
                }
                this.showShadow = false;
                window.location.reload();
            }).catch(err => {
                console.log(err);
            });
        },
        handleRemove(file, fileList) {
            if (file.response) {
                let imgUrl = file.response.data.imgUrl + ';';
                this.imgUrlStr = this.imgUrlStr.split(imgUrl).join('');
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleAvatarSuccess(res, file) {
            if (!+res.code) {
                let str = res.data.imgUrl + ';';
                this.imgUrlStr += str;
            } else {
                this.$message(res.msg);
            }
        },
        beforeAvatarUpload(file) {
            const isJPB = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPB) {
                this.$message.error('上传图片只能是 jpeg/png/bmp 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过2MB!');
            }
            return isJPB && isLt2M;
        },
        async getOrderDetail() {
            let res = await this.$api.queryTradeInfo({
                feedBackId: this.feedBackId
            });
            if (res.code === 0) {
                this.goodsList = [res.data.tradeInfo];
                this.refundList = res.data.refundInfos;
            }
        },
        async getDetail() {
            let res = await this.$api.feedbackDetailInfo({
                feedBackId: this.feedBackId
            });
            if (res.code === 0) {
                // 接口成功做的操作
                
				const tempButtonList = res.data.statusAndButtonList.buttonList;
                this.statusList = res.data.statusAndButtonList.statusList;
                this.statusList.forEach(item => {
                    item.statusActive = 0;
                    item.statusList = [];
                    const tempStatusList = item.data;
                    // 接口成功做的操作
                    for (const stepname in tempStatusList) {
                        item.statusList.push({
                            key: tempStatusList[stepname].split('|')[0],
                            value: tempStatusList[stepname].split('|')[1]
                        });
                        if (+tempStatusList[stepname].split('|')[1] === 1) {
                            item.statusActive++;
                        }
                    }
                });
                for (const keyname in tempButtonList) {
                    this.buttonList.push({
                        key: tempButtonList[keyname].split('|')[0],
                        value: tempButtonList[keyname].split('|')[1]
                    });
                }
                this.consultList = res.data.operateHistoryList;
                this.merchantInfo = res.data.merchantInfo || null;
                this.customerComplainInfo = res.data.customerComplainInfo;
                if (res.data.statusAndButtonList.context.indexOf('|') > -1) {
                    this.contextList = res.data.statusAndButtonList.context.split('|');
                }
                else {
                    this.contextList = [res.data.statusAndButtonList.context];
                }
            }
            else {
                this.$message.error(res.msg);
            }
        }
    }
}
</script>
<style lang="less">
.myComplaint-detail {
    position: relative;
    .showImg {
        width: 100px;
        height: 100px;
        background-size: cover;
        margin-right: 15px;
    }
    .showImg:hover {
        cursor: pointer;
    }
    .timeline-img {
        margin-top: 10px;
    }
    .shadow {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        text-align: center;
        background: rgba(0,0,0,.7);
        z-index: 10;
        .offline-refund {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 600px;
            min-height: 200px;
            background: #fff;
            border-radius: 4px;
            border: 1px solid #ebeef5;
            font-size: 18px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            text-align: left;
            padding: 15px 15px;
            .close {
                position: absolute;
                right: 15px;
                top: 10px;
                font-size: 25px;
                color: #606266;
            }
            .confirm-title {
                text-align: center;
                font-size: 18px;
                color: #303133;
                font-weight: 400;
            }
            .confirm-tip {
                padding: 10px;
                font-size: 14px;
                color: red;
            }
            .mixing {
                color: red;
                margin-right: 3px;
            }
            .merchant-input {
                color: #606266;
                font-size: 14px;
            }
            .alert-button {
                margin-top: 15px;
                text-align: right;
            }
            .upload {
                margin-top: 10px;
            }
            .pic-rules {
                color: #606266;
                font-size: 14px;
            }
        }
    }
    .notice {
        color: red;
        padding-top: 20px;
    }
    .refundnotice {
        padding-left: 9px;
    }
    .contextline {
        line-height: 30px;
    }
    .redfont {
        color: red;
    }
    .canrefundmoney {
        padding-left: 6PX;
        color: red;
	}
    .steprow {
        margin-bottom: 20px;
    }
    .btnrow {
        margin-bottom: 10px;
    }
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border: solid 1px #EBEEF5;
        color: #303133;
        font-size: 20px;
        padding: 20px 15px;
        border-radius: 4px;
        margin: 0 0 20px 0;
        .title-text {
            display: flex;
            align-items: center;
        }
    }
    /* .el-dialog__footer {
        text-align: center;
        .closebtn {
            margin-right: 40px;
        }
    } */
    
    .area-title {
        margin-bottom: 16px;
        margin-top: 32px;
    }
    .status {
        font-size: 14px;
        color: rgb(29, 152, 255);
    }
    .money {
        font-weight: bold;
        font-size: 18px;
        padding-left: 20px;
    }
    .refundtype {
        position: relative;
        .el-form-item__content {
            margin-left: 80px;height: 20px;
        }
    }
    .goods-picurl {
        height: 80px;
        width: 80px;
    }
    .refundradio {
        left: -72px;
        position: absolute;
    }
    .refundradior {
        left: 130px;
        position: absolute;
    }
    .item-wrap {
        display: flex;
        margin-bottom: 8px;
    }
    .timeline-container {
        margin-top: 16px;
    }
    .left-padding {
        padding-left: 20px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
}
</style>